import { createActions, handleActions } from "redux-actions";

const getDefaultNavSettingConfig = () => {
  let navSettingConfig;
  try {
    navSettingConfig = localStorage.getItem("navSettingConfig");
    if (navSettingConfig) {
      navSettingConfig = JSON.parse(navSettingConfig);
    }
  } catch (e) {
    // ignore
  }
  if (!navSettingConfig) {
    navSettingConfig = {
      isDarkNav: true,
      navs: [
        { value: "chat", visible: true },
        { value: "comment", visible: true },
        { value: "ais", visible: true },
        { value: "marketing", visible: true },
        { value: "history", visible: true },
        { value: "engage", visible: true },
        { value: "report", visible: true },
        { value: "empower", visible: true },
        { value: "popularize", visible: true },
      ],
    };
  }
  return navSettingConfig;
};

const initState = getDefaultNavSettingConfig();

export const { mergeNavSetting } = createActions({
  mergeNavSetting: (result) => result,
});

const navSetting = handleActions(
  {
    [mergeNavSetting]: (state, action) => {
      if (action.payload) {
        return Object.assign({}, state, action.payload);
      }
      return state;
    },
  },
  initState,
);

export default navSetting;
